import { render, staticRenderFns } from "./new_cnab_remittance.vue?vue&type=template&id=1ce6795d&scoped=true&"
import script from "./new_cnab_remittance.vue?vue&type=script&lang=js&"
export * from "./new_cnab_remittance.vue?vue&type=script&lang=js&"
import style0 from "./new_cnab_remittance.vue?vue&type=style&index=0&id=1ce6795d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ce6795d",
  null
  
)

export default component.exports